export function normalizeMatchConfig(input = {}) {
  const config = { ...input };

  const ensureArray = (value) => (Array.isArray(value) ? value : []);

  config.team1PlayingPlayers = ensureArray(config.team1PlayingPlayers);
  config.team2PlayingPlayers = ensureArray(config.team2PlayingPlayers);
  config.team1SquadPlayers = ensureArray(config.team1SquadPlayers);
  config.team2SquadPlayers = ensureArray(config.team2SquadPlayers);

  config.team1SubstitutePlayers = ensureArray(config.team1SubstitutePlayers);
  config.team2SubstitutePlayers = ensureArray(config.team2SubstitutePlayers);

  config.team1UnannouncedPlayers = ensureArray(config.team1UnannouncedPlayers);
  config.team2UnannouncedPlayers = ensureArray(config.team2UnannouncedPlayers);

  config.team1MatchPlayers = ensureArray(config.team1MatchPlayers);
  config.team2MatchPlayers = ensureArray(config.team2MatchPlayers);

  config.team1AnnouncedPlayers = ensureArray(config.team1AnnouncedPlayers);
  config.team2AnnouncedPlayers = ensureArray(config.team2AnnouncedPlayers);

  if (!config.team1AnnouncedPlayers.length) {
    config.team1AnnouncedPlayers = [
      ...config.team1PlayingPlayers,
      ...config.team1SubstitutePlayers,
    ];
  }

  if (!config.team2AnnouncedPlayers.length) {
    config.team2AnnouncedPlayers = [
      ...config.team2PlayingPlayers,
      ...config.team2SubstitutePlayers,
    ];
  }

  const team1MatchPlayers = config.team1MatchPlayers;
  if (!config.team1PlayingPlayers.length && team1MatchPlayers.length) {
    config.team1PlayingPlayers = team1MatchPlayers
      .filter((entry) => entry?.status === 'playing')
      .map((entry) => entry?.playerId)
      .filter(Boolean);
  }
  if (!config.team1SubstitutePlayers.length && team1MatchPlayers.length) {
    config.team1SubstitutePlayers = team1MatchPlayers
      .filter((entry) => entry?.status === 'substitute')
      .map((entry) => entry?.playerId)
      .filter(Boolean);
  }
  if (!config.team1UnannouncedPlayers.length && team1MatchPlayers.length) {
    config.team1UnannouncedPlayers = team1MatchPlayers
      .filter((entry) => entry?.status === 'unannounced')
      .map((entry) => entry?.playerId)
      .filter(Boolean);
  }

  const team2MatchPlayers = config.team2MatchPlayers;
  if (!config.team2PlayingPlayers.length && team2MatchPlayers.length) {
    config.team2PlayingPlayers = team2MatchPlayers
      .filter((entry) => entry?.status === 'playing')
      .map((entry) => entry?.playerId)
      .filter(Boolean);
  }
  if (!config.team2SubstitutePlayers.length && team2MatchPlayers.length) {
    config.team2SubstitutePlayers = team2MatchPlayers
      .filter((entry) => entry?.status === 'substitute')
      .map((entry) => entry?.playerId)
      .filter(Boolean);
  }
  if (!config.team2UnannouncedPlayers.length && team2MatchPlayers.length) {
    config.team2UnannouncedPlayers = team2MatchPlayers
      .filter((entry) => entry?.status === 'unannounced')
      .map((entry) => entry?.playerId)
      .filter(Boolean);
  }

  return config;
}
